module.exports = __webpack_public_path__ + "static/media/text.44b3ee53.svg";